import { BasicPokemonInfoI } from "interfaces";
import { PokemonsPageResponseI } from "interfaces/pokemonsPageRequest.interface";
import { useEffect, useState } from "react";
import { getPokemons } from "../apis/pokemons";

export function useFetchPokemons(
  search: string,
  formData: {},
  page?: number
): [BasicPokemonInfoI[], number | null, boolean] {
  const [pokemons, setPokemons] = useState<BasicPokemonInfoI[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [nextPage, setNextPage] = useState<number | null>(null);

  useEffect(() => {
    let cancel = false;
    async function fetchData() {
      try {
        setIsLoading(true);
        const fetchedPokemons: PokemonsPageResponseI = await getPokemons(
          search,
          formData,
          page
        );
        if (!cancel) {
          if (page && page !== 1) {
            setIsLoading(false);
            setPokemons((previousPokemons) => [
              ...previousPokemons,
              ...fetchedPokemons.results,
            ]);
          } else {
            setIsLoading(false);
            setPokemons(fetchedPokemons.results);
          }
          setNextPage(fetchedPokemons.next_page_number);
        }
      } catch (error) {
        console.log("ERREUR");
        setError("Erreur");
      }
    }
    fetchData();
    return () => {
      cancel = true;
    };
  }, [search, formData, page]);

  return [pokemons, nextPage, isLoading];
}
